export default __webpack_public_path__ + "static/media/020-television.9346f329.png";